import { render, staticRenderFns } from "./ncc_version.vue?vue&type=template&id=c185e508&scoped=true"
import script from "./ncc_version.vue?vue&type=script&lang=js"
export * from "./ncc_version.vue?vue&type=script&lang=js"
import style0 from "./ncc_version.vue?vue&type=style&index=0&id=c185e508&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_babel-core@6.26.3_cache-loader@4.1.0_css-loader@3.6_es6nbxkbffq4rffv33bwkugdri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c185e508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bluetooth-light-web\\node_modules\\.pnpm\\registry.npmmirror.com+vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c185e508')) {
      api.createRecord('c185e508', component.options)
    } else {
      api.reload('c185e508', component.options)
    }
    module.hot.accept("./ncc_version.vue?vue&type=template&id=c185e508&scoped=true", function () {
      api.rerender('c185e508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ncc/ncc_version.vue"
export default component.exports